<p>{{ title }}</p>
<p>{{ message }}</p>
<button type="button" mat-raised-button
        (click)="dialogRef.close(true)">OK</button>
<button type="button" mat-button
        (click)="dialogRef.close()">Cancel</button>
